'use client';

import { useLocale } from 'next-intl';
import { resolveLocale } from '@/i18n/locales';
import { buildLocalizedPath } from '@/shared/utils/i18n/locale-path';
import { REDIRECT_CHECKOUT_ROUTE } from '@/shared/constants/routes';

export const useCheckoutHref = (): string => {
  const locale = useLocale();
  return buildLocalizedPath(resolveLocale(locale), REDIRECT_CHECKOUT_ROUTE);
};
